import Route from '@ember/routing/route';
import { set } from '@ember/object';
import { service } from '@ember/service';
import { routeEvent } from 'garaje/utils/decorators/route';

export default class WorkplaceSettingsEmployeesRegistrationRoute extends Route {
  title = 'Workplace · Employee registration · Envoy';

  @service abilities;
  @service flow;
  @service store;
  @service transitionConfirm;
  @service router;
  @service flashMessages;

  async beforeModel(transition) {
    // Redirect users without any employee flow permissions
    if (
      this.abilities.cannot('view employee registration flow for workplace') &&
      this.abilities.cannot('edit employee registration flow for workplace')
    ) {
      this.router.transitionTo('workplace.settings.employees.registration.index');
      return;
    }

    const flowId = transition.to.params.flow_id;

    // Validate flow_id parameter
    if (!flowId || (typeof flowId !== 'string' && typeof flowId !== 'number')) {
      this.flashMessages.showAndHideFlash('error', 'Invalid flow ID');
      this.router.transitionTo('workplace.settings.employees.registration.index');
      return;
    }

    try {
      const employeeScreeningFlow = await this.flow.getFlowWithIncludes(flowId);
      return employeeScreeningFlow;
    } catch (error) {
      // Handle errors loading the flow (permissions, not found, etc.)
      this.flashMessages.showAndHideFlash('error', 'Unable to load employee registration flow');
      this.router.transitionTo('workplace.settings.employees.registration.index');
      return;
    }
  }

  async model(params) {
    const model = {
      flow: null,
      signInFieldPage: null,
      signInFields: null,
      agreementPage: null,
      summaryPage: null,
      signInFieldActionRuleGroups: null,
      groups: [],
      ipads: [],
      locations: [],
    };

    model.flow = this.store.peekRecord('employee-screening-flow', params.flow_id);

    // Ensure flow was loaded successfully in beforeModel
    if (!model.flow) {
      this.flashMessages.showAndHideFlash('error', 'Flow not found');
      this.router.transitionTo('workplace.settings.employees.registration.index');
      return model;
    }
    model.agreementPage = await model.flow.agreementPage;
    model.summaryPage = await model.flow.summaryPage;
    model.signInFieldPage = await model.flow.signInFieldPage;
    model.signInFields = model.signInFieldPage ? await model.signInFieldPage.signInFields : [];
    model.signInFieldActionRuleGroups = await model.flow.signInFieldActionRuleGroups;
    model.groups = this.store.peekAll('group');
    model.locations = await model.flow.locations;

    this.flow.selectedEmployeeScreeningFlow = model.flow;

    return model;
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    set(controller, 'selectedLocations', model.locations.slice());
  }

  @routeEvent
  routeWillChange(transition) {
    const { isDirty, rollbackAll } = this.controller;

    if (isDirty()) {
      this.transitionConfirm.displayConfirmTask.perform(transition, {
        continue() {
          rollbackAll();
        },
      });
    }
    return true;
  }
}
